import { makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { ProductOverviewResolver } from './resolvers/product-overview.resolver';
import { ProductEffects } from './store/effects/product.effects';
import * as productReducer from './store/reducers/product.reducer';

export function provideProductFeature() {
  return makeEnvironmentProviders([
    provideState('productModule', productReducer.reducer),
    provideEffects(ProductEffects),
    ProductOverviewResolver,
  ]);
}
